import React from 'react';
import { useListBoxSection } from 'react-aria';
import MenuList from 'components/MenuList';

import ListBoxOption from '../ListBoxOption';
import { ListBoxData } from '../types';
import { ListBoxSectionTitleProps } from './types';

const ListBoxSectionContent = <T extends ListBoxData = ListBoxData>(
  props: ListBoxSectionTitleProps<T>,
): React.ReactElement => {
  const { section, state } = props;

  const { itemProps, headingProps, groupProps } = useListBoxSection({
    heading: section.rendered,
    'aria-label': section['aria-label'],
  });

  return (
    <MenuList.Section
      headingProps={headingProps}
      groupProps={groupProps}
      title={section.rendered}
    >
      {Array.from(section.childNodes).map((childItem) => {
        switch (childItem.type) {
          // Leaves an open posibility for rendering items in a tree arrangement
          // Although some level arrangements should be done for having an indentation
          // between the nested sections.
          case 'section':
            return (
              <ListBoxSectionContent
                key={childItem.key}
                section={childItem}
                state={state}
              />
            );
          default:
            return (
              <ListBoxOption
                {...itemProps}
                key={childItem.key}
                item={childItem}
                state={state}
              />
            );
        }
      })}
    </MenuList.Section>
  );
};

export default ListBoxSectionContent;
